import { Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

interface CardProps {
  value: number;
  label: string;
}

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#e9f0f7',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  boxShadow: 'rgb(2, 2, 77) 0px 3px 6px -2px, rgba(0, 0, 0, 0.3) 0px 3px 3px -3px',
  margin: '0px 10px',
}));

const Card: React.FC<CardProps> = ({ value, label }) => {
  return (
    <Item className='cursor card-hover'>
      <div>
        <p className='text-center m-0 p-0 APP-color fs-30'><b>{value}</b></p>
        <p className='text-center p-16 gray'>{label}</p>
      </div>
    </Item>
  );
};

export default Card;
